import React, { Component } from 'react';

export default class PPTPlayer extends Component {

    render() {
        const { contentStorageKey } = this.props.contentInfo
        const unzippedContentBucket = process.env.REACT_APP_UNZIPPED_CONTENT_BUCKET || 'classetunzippedcontent-old';
        const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';

        return <div style={{ height: '73vh' }}>
            {contentStorageKey && contentStorageKey.length && contentStorageKey.indexOf('.zip') ? <iframe width={'100%'} height={'100%'} controlsList="nodownload" className=" iframe_video" allowFullScreen={true} src={`https://s3.${awsRegion}.amazonaws.com/${unzippedContentBucket}/${contentStorageKey && contentStorageKey.length && contentStorageKey.split('.')[0]}/index.html`}></iframe> : <span>No Results Found</span>}
        </div>;
    }
}
